/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiRequestManageTicketTags } from '../../models/api-request-manage-ticket-tags';
import { ApiResponseManageTicketTags } from '../../models/api-response-manage-ticket-tags';

export interface CreateTags$Params {
      body: ApiRequestManageTicketTags
}

export function createTags(http: HttpClient, rootUrl: string, params: CreateTags$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseManageTicketTags>> {
  const rb = new RequestBuilder(rootUrl, createTags.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseManageTicketTags>;
    })
  );
}

createTags.PATH = '/v1/api/ui/manage-ticket-tags/create';
